import invite from './invite.jst';
import invite_all from './invite_all.jst';

export default {
	invite,
	invite_all
};